module.exports = __webpack_public_path__ + "img/logo-solena-mono-white.fd8f2d67.png";